import axios from "axios";
import { isPreviewModeActive } from "@/context/PreviewContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Platform Admin has flipped the Draft Preview toggle for this session —
  // tag every request so backend `read_published()` bypasses snapshots and
  // reads raw drafts. Server-side gate still verifies platform-admin, so a
  // non-admin who slips this header through gets normal published data.
  if (isPreviewModeActive()) config.headers["X-Preview-Mode"] = "draft";
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("wk_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
